import { type CommonAction, response, success } from "@iflyrpa/share";
import type { ActiomCommonParams, Toutiao } from "../../types";
import { Http } from "../../utils/http";

export interface SearchToutiaoLocationParams extends ActiomCommonParams {
    placeName: string;
}

export type PublishAction = CommonAction<SearchToutiaoLocationParams, Toutiao.CityPoi[]>;

export const searchToutiaoLocation: PublishAction = async (_task, params) => {
    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
            referer: "https://mp.toutiao.com/profile_v4/graphic/publish",
            biz: 1231,
        },
    });

    const res = await http.api<{
        code: number;
        message: string;
        data: {
            poi: Array<{
                name: string;
                city: string;
                longitude: number;
                latitude: number;
                type_code: string;
                id: string;
            }>;
        };
    }>({
        method: "post",
        url: "https://mp.toutiao.com/poi/api/searchplace",
        data: {
            appid: 1231,
            device: 2,
            keywords: params.placeName,
            language: "zh-CN",
            location: "-1,-1",
            offset: 20,
            page: 1,
            region: "CN",
            scenario: "TIPS",
            timestamp: Math.floor(Date.now() / 1000),
        },
    });

    if (res.code === 414) {
        return success(
            res.data.poi.map((item) => ({
                position: item.name,
                city: item.city,
                longitude: item.longitude,
                latitude: item.latitude,
                type_code: item.type_code,
                poi_id: item.id,
            })),
        );
    }

    const isSuccess = res.code === 0;
    const message = `搜索头条用户ID成功${isSuccess ? "成功" : `失败，原因：${res.message}`}`;
    const data = isSuccess
        ? res.data.poi.map((item) => ({
              position: item.name,
              city: item.city,
              longitude: item.longitude,
              latitude: item.latitude,
              type_code: item.type_code,
              poi_id: item.id,
          }))
        : [];

    return response(isSuccess ? 0 : 414, message, data);
};
